export default __webpack_public_path__ + "static/media/af7.be35f8ef.jpg";